import { forwardRef } from "react";
import { Label } from "../Label/Label";
import { TextareaProps } from "../types";
import { findError } from "../util";
import { FormFieldError } from "../FormFieldError/FormFieldError";
import { READ_ONLY_CLASSES } from "../styles";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { label, errors, description, helperText, descriptionType, ...inputProps },
    ref
  ) => {
    const { name } = inputProps;
    const { className, onKeyDown, ...remainingInputProps } = inputProps;

    const error = findError(name, errors);

    return (
      <div className="mb-5">
        <Label
          label={label}
          name={name}
          description={description}
          descriptionType={descriptionType}
        />
        <textarea
          className={`block border border-gray-200 disabled:bg-gray-100 focus:ring-primary-focus-30 active:border-primary-focus focus:border-primary-focus focus-visible:outline-none ${READ_ONLY_CLASSES} py-3 px-4 pr-8 w-full rounded ${
            className ?? ""
          }`}
          id={inputProps.name}
          ref={ref}
          onKeyDown={onKeyDown}
          {...remainingInputProps}
        />
        {helperText && (
          <p className="text-xs text-gray-600 mt-1">{helperText}</p>
        )}
        {error && (
          <FormFieldError error={error.message?.toString() || "required"} />
        )}
      </div>
    );
  }
);
